var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M7 9v1c0 .5.4 1 1 1s1-.4 1-1V9h1c.5 0 1-.4 1-1s-.4-1-1-1H9V6c0-.5-.4-1-1-1s-1 .4-1 1v1H6c-.5 0-1 .4-1 1s.4 1 1 1h1zM2 8c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z"}));
}

Plus.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Plus;

Plus.default = Plus;
